import AxiosFactory from "api/Axios/axiosFactory";

const baseURL = process.env.REACT_APP_AUTOMATE_API_BASE_URL ?? "https://n8n.storymetrics.ai";
const Axios = new AxiosFactory(baseURL).createInstance();

export default Axios;